// Angular modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//routing
import { SharedPipesRoutingModule } from './shared-pipes-routing.module';

//Pipes
import { PhonePipe } from '../../shared/pipes/phone.pipe';
import { FilterPipe } from '../../shared/pipes/filter.pipe';
import { PropRemainingTermPipe } from '../../shared/pipes/prop-remaining-term.pipe';
import { YearsGapBetweenDatesPipe } from '../../shared/pipes/years-gap-between-dates.pipe';
import { YearsMonthConverterPipe } from '../../shared/pipes/years-month-converter.pipe';
import { ArrayFilterPipe } from '../../shared/pipes/array-filter.pipe';
import { NumberToWordsPipe } from '../../shared/pipes/number-to-words.pipe';
import { arraySearch } from '../../shared/pipes/arraySearch.pipe';
import { FormatString } from '../../shared/pipes/format-string.pipe';
import { ShortnumberPipe } from '../../shared/pipes/shortnumber.pipe';
import { NicedatepipePipe } from '../pipes/nicedatepipe.pipe';
import { ToNumberPipe } from '../pipes/toNumber';

@NgModule({
    imports: [
        CommonModule,
        SharedPipesRoutingModule,
    ],
    exports: [
        FilterPipe,
        PropRemainingTermPipe,
        YearsGapBetweenDatesPipe,
        YearsMonthConverterPipe,
        ArrayFilterPipe,
        arraySearch,
        FormatString,
        PhonePipe,
        ShortnumberPipe,
        NicedatepipePipe,
        ToNumberPipe
    ],
    declarations: [
        NumberToWordsPipe,
        FilterPipe,
        PropRemainingTermPipe,
        YearsGapBetweenDatesPipe,
        YearsMonthConverterPipe,
        ArrayFilterPipe,
        arraySearch,
        FormatString,
        PhonePipe,
        ShortnumberPipe, 
        NicedatepipePipe, 
        ToNumberPipe
      ],
    providers: [NumberToWordsPipe]
})
export class SharedPipesModule { }
